import { Component } from '@angular/core';

@Component({
  templateUrl: './system-settings.page.html',
})
/**
 * System Settings Page!
 */
export class SystemSettingsPage {}
